module.exports = __webpack_public_path__ + "img/img-error.15dd3672.png";